<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import TimeOffInfoPanel from '../../../../../../time-off/components/panels/TimeOffInfoPanel.vue'

import { SiteID } from '../../../../../../sites/models/site'
import { TimeOffRequest } from '../../../../../../time-off/models/timeOffRequest'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { siteId, timeOffRequest } = defineProps<{
  siteId: SiteID
  timeOffRequest: TimeOffRequest
}>()
</script>

<template>
  <TimeOffInfoPanel :site-id="siteId" :time-off-request="timeOffRequest" />
</template>
